import { createSelector } from 'reselect'
import { getGates, isInDriftIntelTrial } from 'app/modules/gates/selectors'

export const getClearbitRevealContext = createSelector(getGates, isInDriftIntelTrial, (gates, isInTrialLocally) => {
  return getClearbitRevealFromGates(gates, isInTrialLocally)
})

const getClearbitRevealFromGates = (gates, isInTrialLocally) => {
  const hasReveal = gates.has('has_reveal')
  const hasLiveReveal = gates.has('has_live_reveal')
  const hasProReveal = gates.has('has_pro_reveal')
  const hasConvoReveal = gates.has('has_conversations_reveal') && gates.get('has_conversations_reveal')
  const hasTargetingReveal = gates.has('has_targeting_reveal')
  const hasCrmReveal = gates.has('has_crm_reveal')

  const isInDriftIntelTrial = gates.has('drift_intel_trial_enabled') || isInTrialLocally
  const driftIntelTrialExpired = gates.has('drift_intel_trial_expired')

  const isDriftIntelTrialActive = !!(isInDriftIntelTrial && !driftIntelTrialExpired && hasProReveal)

  return {
    hasRevealIntegration: hasReveal,
    hasProReveal: hasProReveal,
    liveReveal: hasLiveReveal,
    conversationsReveal: hasConvoReveal,
    targetingReveal: hasTargetingReveal,
    crmReveal: hasCrmReveal,
    leadRoutingReveal: gates.has('has_lead_routing_reveal'),
    abmReveal: gates.has('has_abm_routing_reveal'),
    isEligibleForLiveRevealUpgradeFlow: hasProReveal && hasLiveReveal === false,
    isEligibleForTargetingUpgradeFlow: hasProReveal && hasTargetingReveal === false,
    isEligibleForConvoUpgradeFlow: hasProReveal && isInDriftIntelTrial && driftIntelTrialExpired,
    isEligibleForContactUpgradeFlow: hasProReveal && hasCrmReveal === false,
    isDriftIntelTrialActive,
    isDriftIntelTrialExpired: driftIntelTrialExpired
  }
}


// WEBPACK FOOTER //
// ./src/scripts/app/modules/enrichment/clearbit/selectors.js